export default text => {
    const el = document.createElement("span")
    el.innerHTML = text
    return el.textContent || el.innerText || ""
}
